export enum PageType {
    PolicyHolder = 'PolicyHolder',
    HouseholdMember = 'HouseholdMember',
    Spouse = 'Spouse',
}
